/* eslint-disable no-console */
import _ from 'underscore';
import { ILogger } from '@bingads-webui-react/copilot-utils';
import { COPILOT_WIDTH } from '@bingads-webui-react/copilot-resizer';
// eslint-disable-next-line import/no-cycle
import { msaDataSessionManagerFactory } from './useMSAConversationRestorationWithCookie';

export { COPILOT_WIDTH };
export const LOG_SCENARIO = 'Copilot';

export type LayoutMode = 'expanded' | 'collapsed';
type LayoutName = 'copilot';

interface ISubLayoutConfig {
  mode?: LayoutMode;
  showCopilot?: any;
  hasCustomizedEvent?: boolean;
}
type LayoutConfig = Record<LayoutName, ISubLayoutConfig>;

export const COPILOT_COLLAPSED_LAYOUT_CONFIG: LayoutConfig = {
  copilot: {
    mode: 'collapsed',
    hasCustomizedEvent: false,
  },
};

export const COPILOT_EXPANDED_LAYOUT_CONFIG: LayoutConfig = {
  copilot: {
    mode: 'expanded',
  },
};

export const fakeLogger: ILogger = {
  trace: /* istanbul ignore next */ (str) => console.log(str),
  error: /* istanbul ignore next */ (str) => console.error(str),
  info: /* istanbul ignore next */ (str) => console.log(str),
};

interface IOnToggleCopilotParams {
  changeLayout(layoutConfig: LayoutConfig): void;
  mode: LayoutMode;
  logger: ILogger;
  customizedEvent?: any;
}

export const onToggleCopilot = ({
  changeLayout, mode, logger, customizedEvent,
}: IOnToggleCopilotParams) => {
  const expandedConfig = COPILOT_EXPANDED_LAYOUT_CONFIG;
  const expanded = mode === 'expanded';
  const newLayoutConfig = expanded ? {
    ...expandedConfig,
    copilot: {
      mode: 'expanded' as LayoutMode,
      hasCustomizedEvent: !_.isEmpty(customizedEvent),
    },
  } : COPILOT_COLLAPSED_LAYOUT_CONFIG;
  const sessionManager = msaDataSessionManagerFactory({ logger });
  sessionManager.saveSessionInfo({
    isOpen: expanded,
    customizedEvent,
  });
  changeLayout(newLayoutConfig);
};
